<template>
    <div class="duration">
        <div
                v-if="!!label"
                class="duration__label mr-3"
        >{{ label }}</div>
        <v-text-field
                v-model.number="hours"
                :label="$t('msg.hours')"
                outlined
                :dense="!isMobile"
                hide-details
                class="duration__input mr-3"
                @change="setModel"
                type="number"
        ></v-text-field>
        <v-text-field
                v-model.number="minutes"
                :label="$t('msg.minutes')"
                outlined
                :dense="!isMobile"
                hide-details
                class="duration__input"
                @change="setModel"
                type="number"
        ></v-text-field>
    </div>
</template>

<script>
    export default {
        props: {
            value: Number,
            label: String
        },
        data() {
            return {
                hours: null,
                minutes: null
            };
        },
        watch: {
            value() {
                this.initModel();
            }
        },
        methods: {
            setModel() {
                let ret = this.hours * 60 + this.minutes;
                if (ret === 0) ret = null;
                this.$emit('input', ret);
            },
            initModel() {
                if (this.value == null) {
                    this.hours = null;
                    this.minutes = null;
                    return;
                }

                let minutes = this.value % 60;
                let hours = (this.value - minutes) / 60;

                this.minutes = minutes === 0 ? null : minutes;
                this.hours = hours === 0 ? null : hours;
            }
        },
        created() {
            this.initModel();
        }
    }
</script>

<style lang="scss">
    .duration {
        display: flex;
        align-items: center;
    }
    .duration__label {
    }
    .duration__input {
        max-width: 100px;
    }
</style>